import { all, fork } from 'redux-saga/effects';

import listenLoadAccountInfo from './listenLoadAccountInfo';

export default function* customerSaga() {
  yield all([fork(listenLoadAccountInfo)]);
}
